var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusNotStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 11.5,
    stroke: "#108CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12L10 16.3301L10 7.66987L17.5 12Z",
    fill: "#108CFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8,
    width: 1,
    height: 8,
    fill: "#108CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNotStarted);
export default __webpack_public_path__ + "static/media/status_not_started.f4d1e6b0f5e033a58053638f428382bd.svg";
export { ForwardRef as ReactComponent };